import { createContext } from 'react';

export const context = createContext<{
  setIsOpen: (is: boolean) => void;
  toggleOpen: () => void;
  isOpen: boolean;
  animationOpenName: string;
  animationClosedName: string;
}>(undefined as any);
